// Page titles, descriptions and JSON-LD for the discipline and Our People pages.
const SITE_URL = 'https://www.ignis.co.uk';
const ORG_ID = `${SITE_URL}/#organization`;

const organizationRef = { '@type': 'Organization', '@id': ORG_ID, name: 'Ignis Ltd', alternateName: 'Ignis London', url: SITE_URL };

// Every page is prerendered to /path/index.html (scripts/prerender.js), which the
// server serves with a trailing slash, so that is the canonical form.
const canonicalUrl = (path) => `${SITE_URL}${path.replace(/\/$/, '')}/`;

const breadcrumbSchema = (name, path) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
    { '@type': 'ListItem', position: 2, name, item: canonicalUrl(path) },
  ],
});

const disciplineSeo = (discipline) => {
  const url = canonicalUrl(discipline.path);
  return {
    title: discipline.title,
    description: discipline.description,
    schemas: [
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        '@id': `${url}#service`,
        name: discipline.name,
        serviceType: discipline.name,
        description: discipline.description,
        url,
        provider: organizationRef,
        areaServed: 'United Kingdom',
      },
      breadcrumbSchema(discipline.name, discipline.path),
    ],
  };
};

const PEOPLE_PATH = '/our-people';

const peopleSeo = (people) => {
  const url = canonicalUrl(PEOPLE_PATH);
  const description = 'Meet the team at Ignis London, an employee-owned brand experience agency working across experiential, shopper marketing, social and digital, and corporate communications.';
  return {
    title: 'Our People | IGNIS',
    description,
    schemas: [
      {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        '@id': `${url}#webpage`,
        url,
        name: 'Our People | IGNIS',
        description,
        about: organizationRef,
        mainEntity: {
          '@type': 'ItemList',
          name: 'The Ignis team',
          itemListElement: people.map((person, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@type': 'Person',
              name: person.name,
              jobTitle: person.jobTitle,
              ...(person.discipline ? { knowsAbout: person.discipline } : {}),
              worksFor: { '@id': ORG_ID },
            },
          })),
        },
      },
      breadcrumbSchema('Our People', PEOPLE_PATH),
    ],
  };
};

module.exports = { SITE_URL, PEOPLE_PATH, canonicalUrl, disciplineSeo, peopleSeo };
